import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex align-items-center position-relative settings-box-wrap for-card-bg-gray",
  style: {"gap":"25px"}
}
const _hoisted_2 = {
  class: "d-flex align-items-center",
  style: {"gap":"5px","margin-top":"10px"}
}
const _hoisted_3 = {
  class: "d-flex align-items-center",
  style: {"gap":"5px","margin-top":"10px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "cursor position-relative active-wrap2",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.setWhite && _ctx.setWhite(...args)))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["settings-box bg-light-40", { 'white-style': !_ctx.isGrayBg }])
      }, _cache[3] || (_cache[3] = [
        _createStaticVNode("<span class=\"bg-white\"></span><span class=\"bg-white\"></span><span class=\"bg-white\"></span><span class=\"bg-white\"></span><span class=\"bg-white\"></span><span class=\"bg-white\"></span><span class=\"bg-white\"></span><span class=\"rounded-3 bg-white\"></span><span class=\"rounded-3 bg-white\"></span><span class=\"rounded-3 bg-white\"></span><span class=\"rounded-3 bg-white\"></span><span class=\"rounded-3 bg-white\"></span><span class=\"rounded-3 bg-white\"></span>", 13)
      ]), 2),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("i", {
          class: _normalizeClass(["ri-checkbox-circle-fill position-relative top-1 fs-18 text-primary", { 'opacity-1': !_ctx.isGrayBg, 'opacity-0': _ctx.isGrayBg }])
        }, null, 2),
        _createElementVNode("i", {
          class: _normalizeClass(["ri-checkbox-blank-circle-line position-relative fs-18 text-light-40 position-absolute start-0 bottom-0", { 'opacity-0': !_ctx.isGrayBg, 'opacity-1': _ctx.isGrayBg }])
        }, null, 2),
        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "fw-semibold" }, "White", -1))
      ])
    ]),
    _createElementVNode("div", {
      class: "cursor position-relative active-wrap1",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.setGray && _ctx.setGray(...args)))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["settings-box", { 'gray-style': _ctx.isGrayBg }])
      }, _cache[5] || (_cache[5] = [
        _createStaticVNode("<span></span><span></span><span></span><span></span><span></span><span></span><span></span><span class=\"rounded-3\"></span><span class=\"rounded-3\"></span><span class=\"rounded-3\"></span><span class=\"rounded-3\"></span><span class=\"rounded-3\"></span><span class=\"rounded-3\"></span>", 13)
      ]), 2),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("i", {
          class: _normalizeClass(["ri-checkbox-circle-fill position-relative top-1 fs-18 text-primary", { 'opacity-1': _ctx.isGrayBg, 'opacity-0': !_ctx.isGrayBg }])
        }, null, 2),
        _createElementVNode("i", {
          class: _normalizeClass(["ri-checkbox-blank-circle-line position-relative fs-18 text-light-40 position-absolute start-0 bottom-0", { 'opacity-0': _ctx.isGrayBg, 'opacity-1': !_ctx.isGrayBg }])
        }, null, 2),
        _cache[6] || (_cache[6] = _createElementVNode("span", { class: "fw-semibold" }, "Gray", -1))
      ])
    ]),
    _createElementVNode("button", {
      class: "card-bg settings-btn",
      id: "card-bg",
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleCardStyleBG && _ctx.toggleCardStyleBG(...args)))
    })
  ]))
}